<!--  -->
<template>
    <div id='approveApplyInfo'>
        <section>
            <h5>
                <div class="title">查看文件</div>
            </h5>
            <div v-if="detail.pathUrlList && detail.pathUrlList.length > 0">
                <div class="infoWrapper" v-for="item,index in detail.pathUrlList" :key="index">
                    <div class="filesWrapper flex-col flex-y-center" @click="windowOpen(item)"
                        v-if="item.pathType == '.png' || item.pathType == '.jpg'|| item.pathType == '.jpeg'">
                        <div class="flex-y-center">
                            <img :src="item.pathUrl" class="file-img" alt="">
                        </div>
                    </div>
                    <div class="filesWrapper" @click="windowOpen(item)" v-else>
                        <div>
                            <img src="@/assets/img/files.png" class="file-icon" alt="">
                            <div class="file-title flex-1">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="data-list" v-else style="margin:80px auto">
                <van-empty image="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png"
                    description="暂无数据" />
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        detail: {
            type: Object,
            default: () => { return {} }
        }
    },
    components: {
    },
    computed: {

    },
    watch: {
        detail: {
            handler(nv, ov) {
                if (nv) {
                    this.xcx = nv.xcxInfo
                }
            },
            deep: true,
        }
    },
    data() {
        return {
            xcx: ''
        };
    },

    mounted() { },

    methods: {
        // 素材预览
        windowOpen(item) {
            window.location.href = item.pathUrl
        },
    }
}

</script>
<style lang='less' scoped>
#approveApplyInfo {
    padding: 20px;
    section {
        padding: 20px;
        background: #ffffff;
        border-radius: 20px;
        h5 {
            padding: 20px 0;
            border-bottom: 1px solid #ccc;
            margin: 0 0 20px 0;
        }
        .infoWrapper {
            > div {
                padding: 10px 0;
                > label {
                }
                label,
                span {
                    display: inline-block;
                }
                label {
                    width: 180px;
                    color: #999999;
                }
            }
        }
        .title {
            padding-left: 20px;
            border-left: 10px solid #0c92f4;
        }
    }
    .detailTable {
        width: 100%;
        padding-top: 10px;
        > div {
            width: 100%;
            display: flex;
            justify-content: space-between;
            > span {
                flex-basis: 25%;
                text-align: center;
                border: 1px solid #999999;
                word-break: break-all;
            }
        }
        .thead {
            background: #f2f2f2;
            > span {
                padding: 5px 0;
                &:not(:last-child) {
                    border-right: 0;
                }
            }
        }
        .tbody {
            > span {
                border-top: 0;
                display: flex;
                i {
                    flex: 1;
                    align-self: center;
                    text-align: center;
                    font-style: normal;
                }
            }
            .box {
                width: 75%;
                > div {
                    display: flex;
                    justify-content: space-between;
                    > span {
                        flex: 1;
                        border: 1px solid #999999;
                        border-left: 0;
                        border-top: 0;
                        padding: 10px 0;
                        display: flex;
                        width: 33.33%;
                        i {
                            flex: 1;
                            align-self: center;
                            text-align: center;
                            font-style: normal;
                            font-size: 24px;
                            display: block;
                            width: 100%;
                            word-break: break-all;
                        }
                    }
                }
            }
        }
    }
    .filesWrapper {
        width: 630px;
        padding: 17px 20px;
        border-radius: 4px;
        background: #fafafe;
        margin-bottom: 20px;
        div {
            display: flex;
            align-items: center;
            .file-icon {
                width: 34px;
                height: 34px;
                margin-right: 10px;
            }
            .file-img {
                width: 100%;
                height: 100%;
            }
            .file-title {
                width: 410px;
                font-size: 24px;
                font-weight: 400;
                color: #4375c9;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
            }
            .size {
                min-width: 133px;
                font-size: 20px;
                font-weight: 400;
                color: #a0acb5;
            }
        }
    }
}
</style>